import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { updateRmaApi } from "../../../../api/support/RMA";
import { UpdateRmaRequestType } from "../../../../types/support";
import useGoToNavigation from "../../../../util/useGotoNavigation";

const useUpdateRma = () => {
  const queryClient = useQueryClient();
  const { goToNavigation } = useGoToNavigation();
  
  const { mutate } = useMutation({
    mutationFn: (data: UpdateRmaRequestType) => updateRmaApi(data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["readRmaList"] });
      queryClient.invalidateQueries({ queryKey: ["readRmaDetail"] });
      goToNavigation("support/rma/detail/" + res?.result?.rmaId, {}, false);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  return { mutate };
};

export default useUpdateRma;
